import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowPathDown: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconArrowPathDown"><Path d="M3.12451 13H7.99998V2.00004H16V13H20.8754L12 23.4058L3.12451 13Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowPathDown;
